import React, { useState } from 'react';
import { Form, InputGroup, Modal } from 'reactstrap';

import { LangServices,StepForm } from '@lainaedge/platformshared';

const langService = LangServices.instance();

/**
 * Props for [[`QueryCreateModal`]] component
 */
interface ModalProps
{
  isShowQueryModal: boolean | undefined;
  handleQuerySave: (reason: string) => void;
  toggleQueryModal: () => void;
  query_item: StepForm.FieldInfo | undefined;
  error: string;
}

/**
 * QueryCreateModal component
 *
 * @component QueryCreateModal
 * @category Component
 */
const QueryCreateModal = ({
  isShowQueryModal,
  handleQuerySave,
  toggleQueryModal,
  query_item,
  error,
}: ModalProps): JSX.Element =>
{
  const [message, setMessage] = useState<string>('');

  const handleCloseEditModal = () =>
  {
    setMessage('');
    toggleQueryModal();
  };

  return (
    <Modal size="lg" isOpen={isShowQueryModal}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">{langService.Translate('Query')}</h5>
        <button
          type="button"
          onClick={handleCloseEditModal}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        {query_item && (
          <div id="query-form" className="twitter-bs-wizard">
            <Form
              onSubmit={(e: React.FormEvent<HTMLFormElement>): void =>
              {
                e.preventDefault();
              }}
            >
              <div className="col-md-12">
                <label className={'col-md-12 col-form-label'}>{langService.Translate('Query message')}:</label>
                <div className="col-md-12">
                  <InputGroup>
                    <input
                      className={'form-control'}
                      name={'reason'}
                      value={message}
                      type="text"
                      onChange={(e: any): void =>
                      {
                        setMessage(e.target.value);
                      }}
                    />
                  </InputGroup>
                </div>
                <div className="col-md-12">
                  {error && <span className="validation-error">{error}</span>}
                </div>
              </div>
            </Form>
          </div>
        )}
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary waves-effect waves-light"
          onClick={(): void => handleQuerySave(message.trim())}
        >
          {langService.Translate('Save')}
        </button>
      </div>
    </Modal>
  );
};
export default QueryCreateModal;
